import { DialogActions } from "../styles";

const ModalActions = ({ children, ...props }) => {
  return (
    <DialogActions aria-labelledby="customized-modal-actions" {...props}>
      {children}
    </DialogActions>
  );
};

export default ModalActions;
